<template>
  <div class="onboarding-dashboard-selection">
    <h1 class="onboarding-dashboard-selection__message">
      {{ $t('components.Onboarding.label.title.dashboardSelectionMessage') }}
    </h1>
    <p class="onboarding-dashboard-selection__required-message">
      {{ $t('components.Onboarding.label.title.requiredMessage') }}
    </p>
    <DashboardSelect
      :value="onboardingData.choosenDashboard"
      :rules="isNotEmptyRule"
      class="onboarding-dashboard-selection__select"
      dense
      required
      outlined
      @select="selectDashboard"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DashboardSelect from '@/components/dashboard/DashboardSelect.vue';
export default {
  name: 'OnboardingDashboardSelection',
  components: { DashboardSelect },
  props: {
    onboardingData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isNotEmptyRule: [
        value => Boolean(value),
      ],
    };
  },
  computed: {
    ...mapState('dashboard', [
      'dashboards',
    ]),
  },
  watch: {
    onboardingData: {
      handler(value) {
        const selectedDashboard = this.dashboards.filter(dashboard => dashboard.id === value.choosenDashboard)[0];

        this.onboardingData.dashboardName = selectedDashboard ? this.getDashboardName(selectedDashboard.data.title) : '';
      },
      deep: true,
    },
  },
  methods: {
    selectDashboard(dashboard) {
      this.onboardingData.choosenDashboard = dashboard;
    },
    getDashboardName(title) {
      return title || this.$t('components.Onboarding.label.title.noTitleDasboard');
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding-dashboard-selection {
  &__message {
    color: #000;
    font-weight: var(--ds-font-weight-semibold);
    font-size: var(--ds-font-size-xl);
    line-height: var(--ds-font-line-height-normal);
  }

  &__required-message {
    color: var(--ds-color-text-2);
    margin-top: var(--ds-spacing-stack-nano);
    font-weight: var(--ds-font-weight-regular);
    font-size: var(--ds-font-size-baseline);
    line-height: var(--ds-font-line-height-normal);
  }

  &__select {
    width: 287px;
    margin-top: var(--ds-spacing-stack-sm);
  }
}
</style>
